import type {PaymentMethod as TPaymentMethod} from 'coreStore/data/basket/types';
import PaymentMethod from './PaymentMethod';
import {isApplePaySupported} from 'coreUtils/utils';

/**
 * Represents ApplePayPaymentMethod
 */
class ApplePayPaymentMethod extends PaymentMethod {
	/**
	 * @construct
	 * @param {TPaymentMethod} paymentMethodObject - object with payment method data
	 */
	constructor(paymentMethodObject: TPaymentMethod) {
		super(paymentMethodObject);
	}

	/**
	 * Returns true if payment method is applicable
	 * @param {string} [productID] - product ID to check applicability
	 * @returns {boolean} - applicability result
	 */
	public isApplicable(productID?: string): boolean {
		return isApplePaySupported() && super.isApplicable(productID);
	}
}

export default ApplePayPaymentMethod;
